webpackJsonp([114276838955818,60335399758886],{

/***/ 137:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"IMRD"}},"allContentfulFooter":{"edges":[{"node":{"emailApplications":"applications.itc@ugent.be","addressRecipient":"International Training Centre","emailStudentMatters":"students.itc@ugent.be","addressCompany":"Ghent University","addressFaculty":"Faculty of Bioscience Engineering","emailGeneralInformation":"imrd@ugent.be","addressStreet":"Coupure Links 653","addressCity":"9000 Gent","addressCountry":"Belgium","sharepointLink":{"url":"https://sharepoint.ugent.be/projects/201500429/SitePages/Home.aspx"},"eConsortLink":{"url":"https://ufora.ugent.be/d2l/le/discovery/view/course/78019"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(283);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(137);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createMailtoLink = exports.toSearchString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toSearchString = exports.toSearchString = function toSearchString() {
	  var searchParams = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  return Object.keys(searchParams).map(function (key) {
	    return key + '=' + encodeURIComponent(searchParams[key]);
	  }).join('&');
	};
	
	var createMailtoLink = exports.createMailtoLink = function createMailtoLink(email, headers) {
	  var link = 'mailto:' + email;
	  if (headers) {
	    link += '?' + toSearchString(headers);
	  }
	  return link;
	};
	
	var Mailto = function (_Component) {
	  _inherits(Mailto, _Component);
	
	  function Mailto() {
	    _classCallCheck(this, Mailto);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Mailto).apply(this, arguments));
	  }
	
	  _createClass(Mailto, [{
	    key: 'render',
	    value: function render() {
	      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      var _props = this.props;
	      var email = _props.email;
	      var obfuscate = _props.obfuscate;
	      var headers = _props.headers;
	      var children = _props.children;
	
	      var others = _objectWithoutProperties(_props, ['email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({ href: createMailtoLink(email, headers) }, others),
	        children
	      );
	    }
	  }, {
	    key: 'renderObfuscatedLink',
	    value: function renderObfuscatedLink() {
	      var _props2 = this.props;
	      var email = _props2.email;
	      var obfuscate = _props2.obfuscate;
	      var headers = _props2.headers;
	      var children = _props2.children;
	
	      var others = _objectWithoutProperties(_props2, ['email', 'obfuscate', 'headers', 'children']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({ onClick: this.handleClick.bind(this), href: 'mailto:obfuscated' }, others),
	        children
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      var _props3 = this.props;
	      var email = _props3.email;
	      var headers = _props3.headers;
	
	      window.location.href = createMailtoLink(email, headers);
	    }
	  }]);
	
	  return Mailto;
	}(_react.Component);
	
	Mailto.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  email: _react.PropTypes.string.isRequired,
	  headers: _react.PropTypes.object,
	  obfuscate: _react.PropTypes.bool
	};
	
	Mailto.defaultProps = {
	  obfuscate: false
	};
	
	exports.default = Mailto;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _util = __webpack_require__(699);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var process = process || { env: {} };
	
	var InlineSVG = function (_React$Component) {
	    _inherits(InlineSVG, _React$Component);
	
	    function InlineSVG() {
	        _classCallCheck(this, InlineSVG);
	
	        return _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).apply(this, arguments));
	    }
	
	    _createClass(InlineSVG, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var children = _ref.children;
	
	            if ("production" !== process.env.NODE_ENV && children != null) {
	                console.info('<InlineSVG />: `children` prop will be ignored.');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Element = void 0,
	                __html = void 0,
	                svgProps = void 0;
	
	            var _props = this.props,
	                element = _props.element,
	                raw = _props.raw,
	                src = _props.src,
	                otherProps = _objectWithoutProperties(_props, ['element', 'raw', 'src']);
	
	            if (raw === true) {
	                Element = 'svg';
	                svgProps = (0, _util.extractSVGProps)(src);
	                __html = (0, _util.getSVGFromSource)(src).innerHTML;
	            }
	            __html = __html || src;
	            Element = Element || element;
	            svgProps = svgProps || {};
	
	            return _react2.default.createElement(Element, _extends({}, svgProps, otherProps, { src: null, children: null,
	                dangerouslySetInnerHTML: { __html: __html } }));
	        }
	    }]);
	
	    return InlineSVG;
	}(_react2.default.Component);
	
	exports.default = InlineSVG;
	
	
	InlineSVG.defaultProps = {
	    element: 'i',
	    raw: false,
	    src: ''
	};
	
	InlineSVG.propTypes = {
	    src: _propTypes.string.isRequired,
	    element: _propTypes.string,
	    raw: _propTypes.bool
	};

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.convertReactSVGDOMProperty = convertReactSVGDOMProperty;
	exports.startsWith = startsWith;
	exports.serializeAttrs = serializeAttrs;
	exports.getSVGFromSource = getSVGFromSource;
	exports.extractSVGProps = extractSVGProps;
	// Transform DOM prop/attr names applicable to `<svg>` element but react-limited
	
	function convertReactSVGDOMProperty(str) {
	    return str.replace(/[-|:]([a-z])/g, function (g) {
	        return g[1].toUpperCase();
	    });
	}
	
	function startsWith(str, substring) {
	    return str.indexOf(substring) === 0;
	}
	
	var DataPropPrefix = 'data-';
	// Serialize `Attr` objects in `NamedNodeMap`
	function serializeAttrs(map) {
	    var ret = {};
	    for (var prop, i = 0; i < map.length; i++) {
	        var key = map[i].name;
	        if (key == "class") {
	            prop = "className";
	        } else if (!startsWith(key, DataPropPrefix)) {
	            prop = convertReactSVGDOMProperty(key);
	        } else {
	            prop = key;
	        }
	
	        ret[prop] = map[i].value;
	    }
	    return ret;
	}
	
	function getSVGFromSource(src) {
	    var svgContainer = document.createElement('div');
	    svgContainer.innerHTML = src;
	    var svg = svgContainer.firstElementChild;
	    svg.remove ? svg.remove() : svgContainer.removeChild(svg); // deref from parent element
	    return svg;
	}
	
	// get <svg /> element props
	function extractSVGProps(src) {
	    var map = getSVGFromSource(src).attributes;
	    return map.length > 0 ? serializeAttrs(map) : null;
	}

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _arrow = __webpack_require__(170);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	__webpack_require__(389);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _angleBracketButton = __webpack_require__(13);
	
	var _angleBracketButton2 = _interopRequireDefault(_angleBracketButton);
	
	var _logo = __webpack_require__(171);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Drawer = function Drawer(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _mediaQueries.Desktop,
	      null,
	      _react2.default.createElement(DefaultDrawer, props)
	    ),
	    _react2.default.createElement(
	      _mediaQueries.Tablet,
	      null,
	      _react2.default.createElement(MobileDrawer, props)
	    ),
	    _react2.default.createElement(
	      _mediaQueries.Mobile,
	      null,
	      _react2.default.createElement(MobileDrawer, props)
	    )
	  );
	};
	
	exports.default = Drawer;
	
	
	var DefaultDrawer = function DefaultDrawer(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: 'white',
	        marginLeft: 'auto',
	        marginRight: '2rem',
	        width: 250
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'stretch',
	          alignContent: 'stretch'
	        }
	      },
	      _react2.default.createElement(_angleBracketButton2.default, {
	        style: {
	          borderTop: '1px solid rgba(0,0,0,0.1)',
	          width: 230,
	          marginLeft: 10,
	          boxShadow: 'none',
	          padding: '1rem'
	        },
	        textStyle: { fontWeight: 400, fontSize: 14, lineHeight: 1 },
	        text: 'Student portal',
	        link: '/student-portal'
	      }),
	      _react2.default.createElement(_angleBracketButton2.default, {
	        style: {
	          borderTop: '1px solid rgba(0,0,0,0.1)',
	          width: 230,
	          marginLeft: 10,
	          boxShadow: 'none',
	          padding: '1rem'
	        },
	        textStyle: { fontWeight: 400, fontSize: 14, lineHeight: 1 },
	        text: 'IMRD universities',
	        link: '/universities'
	      }),
	      _react2.default.createElement(_angleBracketButton2.default, {
	        style: {
	          borderTop: '1px solid rgba(0,0,0,0.1)',
	          width: 230,
	          marginLeft: 10,
	          boxShadow: 'none',
	          padding: '1rem'
	        },
	        textStyle: { fontWeight: 400, fontSize: 14, lineHeight: 1 },
	        text: 'Student stories',
	        link: '/student-stories'
	      }),
	      _react2.default.createElement(_angleBracketButton2.default, {
	        style: {
	          borderTop: '1px solid rgba(0,0,0,0.1)',
	          borderBottom: '1px solid rgba(0,0,0,0.1)',
	          width: 230,
	          marginLeft: 10,
	          boxShadow: 'none',
	          padding: '1rem'
	        },
	        textStyle: { fontWeight: 400, fontSize: 14, lineHeight: 1.2 },
	        text: 'Learning outcomes<br />& Course content',
	        link: '/learning-outcomes-and-course-content',
	        caretStyle: { width: 12, marginRight: -2 }
	      }),
	      _react2.default.createElement(_logo2.default, {
	        style: {
	          height: '4rem',
	          width: '4rem',
	          margin: '1.5rem 1rem .25rem',
	          alignSelf: 'flex-end'
	        },
	        color: '#f7f7f7'
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'contact',
	          onClick: props.toggle,
	          style: {
	            alignSelf: 'flex-end',
	            marginRight: '1.175rem',
	            fontSize: 13,
	            marginBottom: '.5rem'
	          }
	        },
	        _react2.default.createElement(
	          'a',
	          { href: '/contact' },
	          'Contact us!'
	        )
	      )
	    )
	  );
	};
	
	var MobileDrawer = function MobileDrawer(props) {
	  return _react2.default.createElement(
	    'div',
	    { id: 'drawer' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'bold', to: '/programme' },
	      _react2.default.createElement(
	        'div',
	        { onClick: props.toggle },
	        'Programme'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'bold', to: '/application' },
	      _react2.default.createElement(
	        'div',
	        { onClick: props.toggle },
	        'Application'
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'bold', to: '/tuition-and-scholarships' },
	      _react2.default.createElement(
	        'div',
	        { onClick: props.toggle },
	        'Tuition &',
	        _react2.default.createElement('br', null),
	        'Scholarships'
	      )
	    ),
	    _react2.default.createElement(
	      ArrowButton,
	      { route: '/student-portal', toggle: props.toggle },
	      'Student portal'
	    ),
	    _react2.default.createElement(
	      ArrowButton,
	      { route: '/universities', toggle: props.toggle },
	      'IMRD universities'
	    ),
	    _react2.default.createElement(
	      ArrowButton,
	      { route: '/student-stories', toggle: props.toggle },
	      'Student stories'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        to: '/learning-outcomes-and-course-content',
	        className: 'arrow',
	        onClick: props.toggle
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'arrowText alignTop' },
	        'Learning outcomes',
	        _react2.default.createElement('br', null),
	        '& Course content'
	      ),
	      _react2.default.createElement(_arrow2.default, { className: 'arrowIcon alignTop' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'contact', onClick: props.toggle },
	      _react2.default.createElement(
	        'a',
	        { href: '/contact' },
	        'Contact us!'
	      )
	    )
	  );
	};
	
	var ArrowButton = function ArrowButton(props) {
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: props.route, className: 'arrow', onClick: props.toggle },
	    _react2.default.createElement(
	      'div',
	      { className: 'arrowText' },
	      props.children
	    ),
	    _react2.default.createElement(_arrow2.default, { className: 'arrowIcon' })
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactMailto = __webpack_require__(38);
	
	var _reactMailto2 = _interopRequireDefault(_reactMailto);
	
	var _logo_white = __webpack_require__(167);
	
	var _logo_white2 = _interopRequireDefault(_logo_white);
	
	var _arrowButton = __webpack_require__(19);
	
	var _arrowButton2 = _interopRequireDefault(_arrowButton);
	
	__webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          fontFamily: "'Libre Franklin', 'sans serif'",
	          fontWeight: 300,
	          fontSize: '14px',
	          backgroundColor: '#F7F7F7'
	        }
	      },
	      _react2.default.createElement(
	        _mediaQueries.Desktop,
	        null,
	        _react2.default.createElement(DefaultFooter, {
	          style: {
	            padding: '1rem 4rem 2rem'
	          },
	          data: data
	        })
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Tablet,
	        null,
	        _react2.default.createElement(DefaultFooter, {
	          style: {
	            padding: '1rem 2rem'
	          },
	          data: data
	        })
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Mobile,
	        null,
	        _react2.default.createElement(MobileFooter, { data: data })
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	
	
	var Column = function Column(_ref) {
	  var style = _ref.style,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: _extends({
	        display: 'flex',
	        flexDirection: 'column',
	        alignContent: 'flex-start',
	        justifyContent: 'flex-start'
	      }, style)
	    },
	    children
	  );
	};
	
	var bold = {
	  fontWeight: 600,
	  fontSize: '14px'
	};
	var DefaultFooter = function DefaultFooter(_ref2) {
	  var data = _ref2.data,
	      style = _ref2.style;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: _extends({
	        display: 'flex',
	        flexDirection: 'row',
	        justifyContent: 'space-between',
	        fontSize: '12px',
	        fontWeight: 300
	      }, style)
	    },
	    _react2.default.createElement(
	      Column,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: _extends({}, bold, { marginBottom: 0 }) },
	        '\xA9 2018 IMRD'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { style: { color: '#549b54' }, to: '/' },
	        'Privacy Policy'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'a',
	        { style: bold, href: data.sharepointLink.url },
	        'SharePoint'
	      ),
	      _react2.default.createElement(
	        'a',
	        { style: bold, href: data.eConsortLink.url },
	        'eConsort'
	      )
	    ),
	    _react2.default.createElement(
	      Column,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: _extends({}, bold, { marginBottom: '.5em' }) },
	        'IMRD Address'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { lineHeight: 1.25 } },
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressCompany
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressFaculty
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressRecipient
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressStreet
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressCity
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressCountry
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Column,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: _extends({}, bold, { marginBottom: '.5em' }) },
	        'Contact us:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { lineHeight: 1.25 } },
	        _react2.default.createElement(
	          'div',
	          null,
	          'general information:'
	        ),
	        _react2.default.createElement(
	          _reactMailto2.default,
	          {
	            email: data.emailGeneralInformation,
	            style: { color: '#549b54' },
	            obfuscate: true
	          },
	          data.emailGeneralInformation
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          null,
	          'information on applications:'
	        ),
	        _react2.default.createElement(
	          _reactMailto2.default,
	          {
	            email: data.emailApplications,
	            style: { color: '#549b54' },
	            obfuscate: true
	          },
	          data.emailApplications
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          null,
	          'information on student matters:'
	        ),
	        _react2.default.createElement(
	          _reactMailto2.default,
	          {
	            email: data.emailStudentMatters,
	            style: { color: '#549b54' },
	            obfuscate: true
	          },
	          data.emailStudentMatters
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Column,
	      { style: { alignItems: 'flex-end' } },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          style: _extends({}, bold, { fontSize: '14px', marginBottom: '.5em' }),
	          to: '/student-portal'
	        },
	        'Student portal'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          style: _extends({}, bold, { fontSize: '14px', marginBottom: '.5em' }),
	          to: '/universities'
	        },
	        'IMRD Universities'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          style: _extends({}, bold, { fontSize: '14px', marginBottom: '.5em' }),
	          to: '/student-stories'
	        },
	        'Student Stories'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          style: _extends({}, bold, { marginBottom: '.5em', textAlign: 'right' }),
	          to: '/learning-outcomes-and-course-content'
	        },
	        'Learning outcomes',
	        _react2.default.createElement('br', null),
	        '& Course content'
	      )
	    )
	  );
	};
	
	var MobileFooter = function MobileFooter(_ref3) {
	  var data = _ref3.data;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'footerContainer',
	      style: {
	        background: 'url(' + _logo_white2.default + ')',
	        backgroundSize: '740px 740px',
	        backgroundRepeat: 'no-repeat',
	        backgroundPosition: 'right bottom'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'linkContainer' },
	      _react2.default.createElement(
	        'table',
	        { cellSpacing: '0', cellPadding: '0' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/programme' },
	                'Programme'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/student-portal' },
	                'Student portal'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/application' },
	                'Application'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/universities' },
	                'IMRD Universities'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement('td', null),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/student-stories' },
	                'Student Stories'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/tuition-and-scholarships' },
	                'Tuition &',
	                _react2.default.createElement('br', null),
	                'Scholarships'
	              )
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/learning-outcomes-and-course-content' },
	                'Learning outcomes',
	                _react2.default.createElement('br', null),
	                '& Course content'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'contactContainer' },
	      _react2.default.createElement(
	        'div',
	        null,
	        'Contact us:'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'general information:'
	      ),
	      _react2.default.createElement(
	        _reactMailto2.default,
	        { email: data.emailGeneralInformation, obfuscate: true },
	        data.emailGeneralInformation
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'information on applications:'
	      ),
	      _react2.default.createElement(
	        _reactMailto2.default,
	        { email: data.emailApplications, obfuscate: true },
	        data.emailApplications
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'information on student matters:'
	      ),
	      _react2.default.createElement(
	        _reactMailto2.default,
	        { email: data.emailStudentMatters, obfuscate: true },
	        data.emailStudentMatters
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'address' },
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressCompany
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressFaculty
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressRecipient
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressStreet
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressCity
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          data.addressCountry
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'sharepointContainer' },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_arrowButton2.default, { route: data.sharepointLink.url, text: 'SharePoint' })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(_arrowButton2.default, { route: data.eConsortLink.url, text: 'eConsort' })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('td', null),
	          _react2.default.createElement('td', null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'legalContainer' },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' },
	              'Privacy Policy'
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '\xA9 2018 IMRD'
	          )
	        )
	      )
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(171);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _imrd = __webpack_require__(280);
	
	var _imrd2 = _interopRequireDefault(_imrd);
	
	var _drawer = __webpack_require__(271);
	
	var _drawer2 = _interopRequireDefault(_drawer);
	
	var _hamburger = __webpack_require__(279);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	var _cross = __webpack_require__(108);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	__webpack_require__(391);
	
	var _mediaQueries = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleScroll = function () {
	      if (!_this.state.drawerOpen) {
	        var newState = _this.getHeaderClass();
	        if (_this.state.headerClass !== newState.headerClass) _this.setState(_extends({}, newState));
	      }
	    };
	
	    _this.closeDrawer = function () {
	      _this.setState(_extends({
	        drawerOpen: false
	      }, _this.getHeaderClass()));
	      _this.again();
	    };
	
	    _this.toggleDrawer = function () {
	      var drawerOpen = _this.state.drawerOpen;
	
	      _this.setState(function (prevState) {
	        return _extends({
	          drawerOpen: !prevState.drawerOpen
	        }, _this.getHeaderClass(!prevState.drawerOpen ? 'navOpen' : null));
	      });
	      if (drawerOpen) _this.again('navOpen');
	    };
	
	    _this.again = function () {
	      if (typeof window !== 'undefined') {
	        window.setTimeout(function () {
	          return _this.setState(_extends({}, _this.getHeaderClass()));
	        }, 0);
	      }
	    };
	
	    _this.getHeaderClass = function (option) {
	      if (option === 'navOpen') return navOpen;else if (option === 'navDefault') return navDefault;
	      if (_this.props.isAtRoot && typeof window !== 'undefined' && window.scrollY < 5) return navDefault;
	      return navAlt;
	    };
	
	    _this.state = _extends({
	      drawerOpen: false
	    }, _this.getHeaderClass());
	    return _this;
	  }
	
	  Header.prototype.componentDidMount = function componentDidMount() {
	    if (window) {
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  };
	
	  Header.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (window) {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  };
	
	  Header.prototype.render = function render() {
	    var closeDrawer = this.closeDrawer,
	        toggleDrawer = this.toggleDrawer;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _mediaQueries.Desktop,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'nav', className: 'unselectable' },
	          _react2.default.createElement(DesktopHeader, {
	            drawerOpen: this.state.drawerOpen,
	            headerClass: this.props.isAtRoot ? this.state.headerClass : 'navAlt',
	            color: this.props.isAtRoot ? this.state.color : 'black',
	            fn: { closeDrawer: closeDrawer, toggleDrawer: toggleDrawer }
	          }),
	          this.state.drawerOpen && _react2.default.createElement(_drawer2.default, { toggle: toggleDrawer })
	        )
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Tablet,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'nav', className: 'unselectable' },
	          _react2.default.createElement(MobileHeader, {
	            drawerOpen: this.state.drawerOpen,
	            headerClass: this.state.headerClass,
	            color: this.state.color,
	            fn: { closeDrawer: closeDrawer, toggleDrawer: toggleDrawer }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Mobile,
	        null,
	        _react2.default.createElement(
	          'div',
	          { id: 'nav', className: 'unselectable' },
	          _react2.default.createElement(MobileHeader, {
	            drawerOpen: this.state.drawerOpen,
	            headerClass: this.state.headerClass,
	            color: this.state.color,
	            fn: { closeDrawer: closeDrawer, toggleDrawer: toggleDrawer }
	          })
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	
	var DesktopHeader = function (_PureComponent) {
	  _inherits(DesktopHeader, _PureComponent);
	
	  function DesktopHeader() {
	    _classCallCheck(this, DesktopHeader);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  DesktopHeader.prototype.render = function render() {
	    var _props = this.props,
	        fn = _props.fn,
	        headerClass = _props.headerClass,
	        color = _props.color,
	        drawerOpen = _props.drawerOpen;
	
	    return _react2.default.createElement(
	      'div',
	      { className: headerClass, style: { padding: '0 2em' } },
	      _react2.default.createElement(
	        'div',
	        { id: 'header' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'brand', to: '/', onClick: fn.closeDrawer },
	          _react2.default.createElement(_logo2.default, { style: { height: '95%' }, color: color }),
	          _react2.default.createElement(_imrd2.default, {
	            style: { height: '55%', marginLeft: '.75em' },
	            color: color
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              flexDirection: 'row',
	              alignItems: 'center',
	              fontWeight: 700,
	              fontSize: '18px'
	            }
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              style: { marginRight: '3vw' },
	              to: '/programme',
	              onClick: fn.closeDrawer
	            },
	            _react2.default.createElement(
	              'div',
	              { className: headerClass, style: { background: 'none' } },
	              'Programme'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              style: { marginLeft: '3vw', marginRight: '3vw' },
	              to: '/application',
	              onClick: fn.closeDrawer
	            },
	            _react2.default.createElement(
	              'div',
	              { className: headerClass, style: { background: 'none' } },
	              'Application'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              style: { marginLeft: '3vw' },
	              to: '/tuition-and-scholarships',
	              onClick: fn.closeDrawer
	            },
	            _react2.default.createElement(
	              'div',
	              { className: headerClass, style: { background: 'none' } },
	              'Tuition & Scholarships'
	            )
	          )
	        ),
	        drawerIcon(drawerOpen, fn.toggleDrawer, color, '55%')
	      )
	    );
	  };
	
	  return DesktopHeader;
	}(_react.PureComponent);
	
	var TabletHeader = function (_PureComponent2) {
	  _inherits(TabletHeader, _PureComponent2);
	
	  function TabletHeader() {
	    _classCallCheck(this, TabletHeader);
	
	    return _possibleConstructorReturn(this, _PureComponent2.apply(this, arguments));
	  }
	
	  TabletHeader.prototype.render = function render() {
	    var _props2 = this.props,
	        fn = _props2.fn,
	        headerClass = _props2.headerClass,
	        color = _props2.color,
	        drawerOpen = _props2.drawerOpen;
	
	    return _react2.default.createElement(
	      'div',
	      { className: headerClass, style: { padding: '0 1em' } },
	      _react2.default.createElement(
	        'div',
	        { id: 'header' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'brand', to: '/', onClick: fn.closeDrawer },
	          _react2.default.createElement(_logo2.default, { style: { height: '80%' }, color: color }),
	          _react2.default.createElement(_imrd2.default, {
	            style: { height: '45%', marginLeft: '.75em' },
	            color: color
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              flexDirection: 'row',
	              alignItems: 'center',
	              fontWeight: 700,
	              fontSize: '20px'
	            }
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              style: { marginRight: '1.5vw' },
	              to: '/programme',
	              onClick: fn.closeDrawer
	            },
	            _react2.default.createElement(
	              'div',
	              { className: headerClass, style: { background: 'none' } },
	              'Programme'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              style: { marginLeft: '1.5vw', marginRight: '1.5vw' },
	              to: '/application',
	              onClick: fn.closeDrawer
	            },
	            _react2.default.createElement(
	              'div',
	              { className: headerClass, style: { background: 'none' } },
	              'Application'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              style: { marginLeft: '1.5vw' },
	              to: '/tuition-and-scholarships',
	              onClick: fn.closeDrawer
	            },
	            _react2.default.createElement(
	              'div',
	              { className: headerClass, style: { background: 'none' } },
	              'Tuition & Scholarships'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TabletHeader;
	}(_react.PureComponent);
	
	var MobileHeader = function (_PureComponent3) {
	  _inherits(MobileHeader, _PureComponent3);
	
	  function MobileHeader() {
	    _classCallCheck(this, MobileHeader);
	
	    return _possibleConstructorReturn(this, _PureComponent3.apply(this, arguments));
	  }
	
	  MobileHeader.prototype.render = function render() {
	    var _props3 = this.props,
	        fn = _props3.fn,
	        headerClass = _props3.headerClass,
	        color = _props3.color,
	        drawerOpen = _props3.drawerOpen;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: headerClass },
	        _react2.default.createElement(
	          'div',
	          { id: 'header' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'brand', to: '/', onClick: fn.closeDrawer },
	            _react2.default.createElement(_logo2.default, { style: { height: '80%' }, color: color }),
	            _react2.default.createElement(_imrd2.default, {
	              style: { height: '45%', marginLeft: '.5rem' },
	              color: color
	            })
	          ),
	          drawerIcon(drawerOpen, fn.toggleDrawer, color)
	        ),
	        drawerOpen && _react2.default.createElement(_drawer2.default, { toggle: fn.toggleDrawer })
	      ),
	      drawerOpen && _react2.default.createElement(
	        'div',
	        { className: 'bottomPadding' },
	        _react2.default.createElement(
	          'span',
	          { onClick: fn.toggleDrawer },
	          'Close'
	        )
	      )
	    );
	  };
	
	  return MobileHeader;
	}(_react.PureComponent);
	
	var navAlt = {
	  headerClass: 'navAlt',
	  color: 'black'
	};
	var navDefault = {
	  headerClass: 'navDefault',
	  color: 'white'
	};
	var navOpen = {
	  headerClass: 'navOpen',
	  color: 'black'
	};
	
	var drawerIcon = function drawerIcon(drawerOpen, toggleDrawer, color) {
	  var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '45%';
	
	  return drawerOpen ? _react2.default.createElement(_cross2.default, {
	    style: { height: height, width: '25px', cursor: 'pointer' },
	    onClick: toggleDrawer,
	    color: color
	  }) : _react2.default.createElement(_hamburger2.default, {
	    style: { height: height, width: '25px', cursor: 'pointer' },
	    onClick: toggleDrawer,
	    color: color
	  });
	};
	module.exports = exports['default'];

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cross = function Cross(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ viewBox: "0 0 48.76 48.76" }, props),
	    _react2.default.createElement("path", {
	      d: "M44.76 48.76a4 4 0 0 1-2.83-1.17L24.38 30 6.83 47.59A4 4 0 0 1 4 48.76a4 4 0 0 1-2.83-1.17 4 4 0 0 1 0-5.66l17.55-17.55L1.17 6.83a4 4 0 0 1 5.66-5.66l17.55 17.55L41.93 1.17a4 4 0 1 1 5.66 5.66L30 24.38l17.59 17.55a4 4 0 0 1 0 5.66 4 4 0 0 1-2.83 1.17z",
	      fill: props.color ? props.color : '#fff'
	    })
	  );
	};
	
	exports.default = Cross;
	module.exports = exports["default"];

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hamburger = function Hamburger(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ viewBox: "0 0 65.65 43.82" }, props),
	    _react2.default.createElement("path", {
	      d: "M61.65 0H4a4 4 0 0 0 0 8h57.65a4 4 0 1 0 0-8z",
	      fill: props.color ? props.color : '#fff'
	    }),
	    _react2.default.createElement("path", {
	      d: "M61.65 17.91H4a4 4 0 0 0 0 8h57.65a4 4 0 1 0 0-8z",
	      fill: props.color ? props.color : '#fff'
	    }),
	    _react2.default.createElement("path", {
	      d: "M61.65 35.82H4a4 4 0 0 0 0 8h57.65a4 4 0 1 0 0-8z",
	      fill: props.color ? props.color : '#fff'
	    })
	  );
	};
	
	exports.default = Hamburger;
	module.exports = exports["default"];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _svgInlineReact = __webpack_require__(252);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ieIMRD = function ieIMRD(props) {
	  return _react2.default.createElement(_svgInlineReact2.default, {
	    style: { height: '55%', width: 100, marginLeft: -20, marginTop: -7 },
	    src: '<svg viewBox="0 0 155.06 44.93" >\n    <path\n      d="M0 44.93V0h9.06v44.93zM57.2 0H66v44.93h-8.86v-29L46.51 36.44h-8.12l-10.7-20.52v29h-8.81V0h8.81l14.79 28.19zM98.93 44.93l-9.76-16.86h-4.66v16.86h-8.74V0H93q7.3 0 11.23 3.84a13.7 13.7 0 0 1 3.94 10.26q0 10.5-9.88 13.15l11 17.68zM84.51 7.55v13.28h7.24q7.31 0 7.3-6.8a6.27 6.27 0 0 0-1.82-4.75 7.52 7.52 0 0 0-5.35-1.73zM116.11 44.93V0h17.18A22 22 0 0 1 145 3.08a19.82 19.82 0 0 1 7.55 8.12 24.41 24.41 0 0 1 2.52 11.08 23.35 23.35 0 0 1-5.85 16.08q-5.85 6.57-16 6.57zm9.06-7.55h7.42a12.35 12.35 0 0 0 9.76-4.25 15.91 15.91 0 0 0 3.71-10.85 15.82 15.82 0 0 0-3.56-10.45 11.83 11.83 0 0 0-9.59-4.28h-7.74z"\n      fill=' + (props.color ? props.color : '#fff') + '\n    />\n  </svg>'
	  });
	};
	
	var IMRD = function IMRD(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '0 0 155.06 44.93' }, props),
	    _react2.default.createElement('path', {
	      d: 'M0 44.93V0h9.06v44.93zM57.2 0H66v44.93h-8.86v-29L46.51 36.44h-8.12l-10.7-20.52v29h-8.81V0h8.81l14.79 28.19zM98.93 44.93l-9.76-16.86h-4.66v16.86h-8.74V0H93q7.3 0 11.23 3.84a13.7 13.7 0 0 1 3.94 10.26q0 10.5-9.88 13.15l11 17.68zM84.51 7.55v13.28h7.24q7.31 0 7.3-6.8a6.27 6.27 0 0 0-1.82-4.75 7.52 7.52 0 0 0-5.35-1.73zM116.11 44.93V0h17.18A22 22 0 0 1 145 3.08a19.82 19.82 0 0 1 7.55 8.12 24.41 24.41 0 0 1 2.52 11.08 23.35 23.35 0 0 1-5.85 16.08q-5.85 6.57-16 6.57zm9.06-7.55h7.42a12.35 12.35 0 0 0 9.76-4.25 15.91 15.91 0 0 0 3.71-10.85 15.82 15.82 0 0 0-3.56-10.45 11.83 11.83 0 0 0-9.59-4.28h-7.74z',
	      fill: props.color ? props.color : '#fff'
	    })
	  );
	};
	
	var isIE = false;
	if (typeof navigator != 'undefined' && navigator.appName == 'Microsoft Internet Explorer' || !!(typeof navigator != 'undefined' && (navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))) || typeof $ !== 'undefined' && typeof $.browser !== 'undefined' && $.browser.msie == 1) {
	  isIE = true;
	}
	
	exports.default = isIE ? ieIMRD : IMRD;
	module.exports = exports['default'];

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _svgInlineReact = __webpack_require__(252);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ieLogo = function ieLogo(props) {
	  return _react2.default.createElement(_svgInlineReact2.default, {
	    style: { height: '95%', width: 50 },
	    src: '<svg viewBox="0 0 934 934" >\n<path\n  d="M467 0C209.5 0 0 209.5 0 467s209.5 467 467 467 467-209.5 467-467S724.5 0 467 0zM92 467c0-192.75 146.25-351.93 333.58-372.62V285l-39.35-49.59a46 46 0 1 0-72.1 57.2l111.45 140.51v79l-97.86-89.38a46 46 0 0 0-62.07 68L425.58 636.8v73L283.9 590.65a46 46 0 1 0-59.23 70.45l212.41 178.6c.48.4 1.06.69 1.57 1.08C245.1 826.22 92 664.21 92 467zm403.46 373.77c.3-.23.63-.39.92-.62L708.79 667a46 46 0 1 0-58.15-71.35L508.42 711.58v-74.82l162-148.63a46 46 0 0 0-62.24-67.81l-99.71 91.51v-78.68L617 297.07a46 46 0 0 0-72-57.4l-36.63 45.91V94.38C695.75 115.07 842 274.25 842 467c0 197.17-153 359.16-346.54 373.77z"\n  fill=' + (props.color ? props.color : '#fff') + '\n/>\n</svg>'
	  });
	};
	
	var logo = function logo(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '0 0 934 934' }, props),
	    _react2.default.createElement('path', {
	      d: 'M467 0C209.5 0 0 209.5 0 467s209.5 467 467 467 467-209.5 467-467S724.5 0 467 0zM92 467c0-192.75 146.25-351.93 333.58-372.62V285l-39.35-49.59a46 46 0 1 0-72.1 57.2l111.45 140.51v79l-97.86-89.38a46 46 0 0 0-62.07 68L425.58 636.8v73L283.9 590.65a46 46 0 1 0-59.23 70.45l212.41 178.6c.48.4 1.06.69 1.57 1.08C245.1 826.22 92 664.21 92 467zm403.46 373.77c.3-.23.63-.39.92-.62L708.79 667a46 46 0 1 0-58.15-71.35L508.42 711.58v-74.82l162-148.63a46 46 0 0 0-62.24-67.81l-99.71 91.51v-78.68L617 297.07a46 46 0 0 0-72-57.4l-36.63 45.91V94.38C695.75 115.07 842 274.25 842 467c0 197.17-153 359.16-346.54 373.77z',
	      fill: props.color ? props.color : '#fff'
	    })
	  );
	};
	
	var isIE = false;
	if (typeof navigator != 'undefined' && navigator.appName == 'Microsoft Internet Explorer' || !!(typeof navigator != 'undefined' && (navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))) || typeof $ !== 'undefined' && typeof $.browser !== 'undefined' && $.browser.msie == 1) {
	  isIE = true;
	}
	
	exports.default = isIE ? ieLogo : logo;
	module.exports = exports['default'];

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.queries = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(273);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(272);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _get2 = __webpack_require__(17);
	
	var _get3 = _interopRequireDefault(_get2);
	
	__webpack_require__(392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(props) {
	  var _get = (0, _get3.default)(props, 'data.allContentfulFooter.edges'),
	      footerContent = _get[0].node;
	
	  var isAtRoot = false;
	  if (props.hasOwnProperty('location') && props.location.hasOwnProperty('pathname')) {
	    isAtRoot = props.location.pathname === '/';
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: props.data.site.siteMetadata.title }),
	    _react2.default.createElement(_header2.default, { isAtRoot: isAtRoot }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          minHeight: getMinHeight()
	        }
	      },
	      !isAtRoot && _react2.default.createElement('div', { style: { height: getHeight() } }),
	      props.children()
	    ),
	    _react2.default.createElement(_footer2.default, { data: footerContent })
	  );
	};
	
	var getHeight = function getHeight() {
	  if (typeof window !== 'undefined') {
	    if (window.innerWidth < 768) {
	      return '3.5rem';
	    } else if (window.innerWidth < 992) {
	      return '3rem';
	    } else {
	      return '2.5rem';
	    }
	  }
	};
	var getMinHeight = function getMinHeight() {
	  if (typeof window !== 'undefined') {
	    if (window.innerWidth < 768) {
	      return 'calc(100vh - 886.6px)';
	    } else if (window.innerWidth < 992) {
	      return 'calc(100vh - 192px)';
	    } else {
	      return 'calc(100vh - 210px)';
	    }
	  }
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var queries = exports.queries = '** extracted graphql fragment **';

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MzQgOTM0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+bG9nbyB3aXQ8L3RpdGxlPjxwYXRoIGNsYXNzPSJhIiBkPSJNNDY3LDBDMjA5LjUsMCwwLDIwOS41LDAsNDY3UzIwOS41LDkzNCw0NjcsOTM0LDkzNCw3MjQuNSw5MzQsNDY3LDcyNC41LDAsNDY3LDBaTTkyLDQ2N0M5MiwyNzQuMjUsMjM4LjI1LDExNS4wNyw0MjUuNTgsOTQuMzhWMjg1bC0zOS4zNS00OS41OWE0Niw0NiwwLDEsMC03Mi4xLDU3LjJMNDI1LjU4LDQzMy4xMnY3OWwtOTcuODYtODkuMzhhNDYsNDYsMCwwLDAtNjIuMDcsNjhMNDI1LjU4LDYzNi44djczTDI4My45LDU5MC42NWE0Niw0NiwwLDEsMC01OS4yMyw3MC40NUw0MzcuMDgsODM5LjdjLjQ4LjQsMS4wNi42OSwxLjU3LDEuMDhDMjQ1LjEsODI2LjIyLDkyLDY2NC4yMSw5Miw0NjdaTTQ5NS40Niw4NDAuNzdjLjMtLjIzLjYzLS4zOS45Mi0uNjJMNzA4Ljc5LDY2N2E0Niw0NiwwLDEsMC01OC4xNS03MS4zNUw1MDguNDIsNzExLjU4VjYzNi43NmwxNjItMTQ4LjYzYTQ2LDQ2LDAsMCwwLTYyLjI0LTY3LjgxbC05OS43MSw5MS41MVY0MzMuMTVMNjE3LDI5Ny4wN2E0Niw0NiwwLDAsMC03Mi01Ny40bC0zNi42Myw0NS45MVY5NC4zOEM2OTUuNzUsMTE1LjA3LDg0MiwyNzQuMjUsODQyLDQ2Nyw4NDIsNjY0LjE3LDY4OSw4MjYuMTYsNDk1LjQ2LDg0MC43N1oiLz48L3N2Zz4="

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-966278bb9b4dd813af04.js